/*eslint-disable*/
import axios from 'axios'
import APP_CONSTANT from '../../config/constants'
const CreateAxios = async function (props = {}) {
    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')

    let congData = JSON.stringify
        ({
            api_token: token,
            customerNo: customerNo,
            userId: userId,
            customerNumber: customerNo,
            ...props.createItems
        })
    // let getData = []
    // console.log('>>', congData)
    // return
    try {
        let response = await axios.post(`${APP_CONSTANT.BASE_URL}${props.url}`, congData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        });

        if (response.status === 200) {
            props.created(response.data)
        }
        // return getData;
    }
    catch (e) {
        return console.log('ErrorRead', e);
    }
}

export default CreateAxios
